<template>
  <mdb-container>
    <Errors v-if="!!error" :error="error" />
    <mdb-row>
      <mdb-col v-if="showSpinner">
        <Spinner />
      </mdb-col>
    </mdb-row>

    <mdb-alert
      color="dark"
      v-if="message"
      @closeAlert="message = false"
      dismiss
    >
      {{ message }}
    </mdb-alert>

    <form @submit.prevent="createAssetState">
      <mdb-col col="12" class="pb-2 justify-content-md-center">
        <mdb-row>

          <mdb-col col="4">
            <mdb-input label="New State Name" v-model="assetStateInfo.name" @change="validateStateName" placeholder="e.g. clean" required />
          </mdb-col>

           <mdb-col col="4">
            <mdb-input label="Description" v-model="assetStateInfo.description" placeholder="additional details" required />
          </mdb-col>
          <mdb-col col="4">
            <mdb-btn
              :disabled="!isDisabled"
              outline="primary"
              type="submit"
              :icon="btnInfo.btnIcon"
              >{{ btnInfo.btnName }}</mdb-btn
            >
          </mdb-col>
        </mdb-row>
      </mdb-col>
    </form>
  </mdb-container>
</template>

<script>
import api from "@/api";
import Errors from "@/components/Errors";
import Spinner from "@/components/Spinner";

import {
  mdbRow,
  mdbCol,
  mdbContainer,
  mdbBtn,
  mdbAlert,
  mdbInput,
} from "mdbvue";

export default {
  components: {
    Errors,
    mdbRow,
    mdbCol,
    mdbContainer,
    mdbBtn,
    mdbAlert,
    Spinner,
    mdbInput
  },

  data() {
    return {
      assetStateInfo: {},
      error: "",
      btnInfo: {},
      isLoading: true,
      message: "",
    };
  },
  methods: {
    newAssetState() {
      return {
        name: "",
        description: "",
      };
    },

    createAssetState() {
      api
        .createAssetState(this.assetStateInfo)
        .then(() => {
          this.$emit("asset-state-created");
          this.reset();
        })
        .catch((error) => {
          this.error = error.response.data.errors.full_messages[0];
        });
    },
    reset() {
      this.assetStateInfo = this.newAssetState();
      this.errors = {};
    },
    setBtnInfo() {
      return { btnName: "Create State", btnIcon: "plus" };
    },
    validateStateName() {
       this.assetStateInfo.name = this.assetStateInfo.name.toLowerCase().replace(' ', '_');
    },
  },

  created() {
    this.assetStateInfo = this.newAssetState();
    this.btnInfo = this.setBtnInfo();
    this.isLoading = false;
  },
  mounted() {},
  computed: {
    showSpinner() {
      return this.isLoading;
    },
    isDisabled() {
      return (
        !!this.assetStateInfo.name &&
        !!this.assetStateInfo.description
      );
    },
  },
};
</script>

<style scoped lang="scss">
.btn {
  color: $black-accent-color;
  border-color: $black-accent-color;
  text-transform: uppercase;

  &:hover {
    background-color: $green-accent-color;
    color: white;
  }
}
</style>
